export const routes = {

    // global
    userProfile: '/profile',
    // Dashboard
    home: '/',
    reports: '/reports',
    reportById: ':reportId',


    //Management

    manageEmployees: '/management/employees',
    manageEmployeeById: ':employeeId',
    addEmployee: '/management/employees/add',

    manageVehicles: '/management/vehicles',
    vehicleOwnership: '/management/vehicle-ownership',
    assignDriver: '/management/assign-driver',

    parkingSlots: '/management/parking-slots',
    parkingReservations: '/management/parking-reservations',

    refuelingLog : '/management/refueling-log',

    //Settings
    settingsProfile: '/settings/profile',
    settingsConfiguration: '/settings/configuration',

    // employee settings
    settingsConfigureDepartment: '/settings/configuration/departments',
    settingsConfigureDepartmentTypes: '/settings/configuration/department-types',
    settingsConfigurePayrollTypes: '/settings/configuration/payroll-types',
    settingsConfigureBloodGroups: '/settings/configuration/blood-groups',
    settingsConfigureDocumentTypes: '/settings/configuration/document-types',
    settingsConfigureDesignationTypes: '/settings/configuration/designation-types',

    // administration settings
    settingsConfigureManageRoles: '/settings/configure/roles-and-permissions',


    settingsConfigureFuelTypes: '/settings/configuration/fuel-types',
    settingsConfigureFuelStation: '/settings/configuration/fuel-stations',
    settingsConfigureRequisitionTypes: '/settings/configuration/requisition-types',

    // vehicle settings
    settingsConfigureVehicleTypes: '/settings/configuration/vehicle-types',
    settingsConfigureVehicleBrands: '/settings/configuration/vehicle-brands',
    settingsConfigureVehicleParkingSlotTypes: '/settings/configuration/vehicle-parking-slot-types',
    settingsConfigureVehicleParkingCampuses: '/settings/configuration/vehicle-parking-campuses',
    settingsConfigureVehicleParkingCampusesAdd: '/settings/configuration/vehicle-parking-campuses/add',
    settingsConfigureVehicleDeviceVendor: '/settings/configuration/vehicle-device-vendor',
    settingsConfigureVehicleTrackingDevices: '/settings/configuration/vehicle-tracking-devices',
    settingsConfigureDeviceMapping: '/settings/configuration/device-mapping',


    // pickup and drop
    managePickupAndDrop: '/settings/configuration/pickup-and-drop',
    manageRoute: '/settings/configuration/route',



    mapPractice: '/map-practice'
}




// export const routesDescription ={
//     home: {
//         name: 'Home',
//         description: 'Home page',
//     },
//     reports: {
//         name: 'Reports',
//         description: 'Reports page'
//     },
//     SettingsProfile: {
//         name: 'Profile',
//         description: 'Profile page'
//     },
//     reportById: {
//         name: 'Report Details',
//         description: 'Report Details page'
//     }
// }